import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m4 6 8-4 8 4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "m18 10 4 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8l4-2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M14 22v-4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 5v17", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 5v17", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "9", r: "2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "School";
const School = memo(themed(Icon));
export {
  School
};
//# sourceMappingURL=school.js.map
